import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { store } from "./store";
import App from "./App";


import "./css/tailwind.css"; 
import "semantic-ui-css/semantic.min.css";
import "react-toastify/dist/ReactToastify.css";



ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

{
  /*<React.StrictMode>
    <App />
</React.StrictMode>, */
}
